// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttonWrapper = "SuccessStep__buttonWrapper__KMBLh";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const noteText = "SuccessStep__noteText__I-lCI";
export const noteTitle = "SuccessStep__noteTitle__VM5dN";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const successStep = "SuccessStep__successStep__iR8a0";